import { render, staticRenderFns } from "./gradePropertiesCard.vue?vue&type=template&id=bfcc9bd0"
import script from "./gradePropertiesCard.vue?vue&type=script&lang=js"
export * from "./gradePropertiesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports